import type React from 'react';

import { DetectionIcon } from '@vlabs/icons';
import { DropdownMenu } from '@vlabs/uikit';
import type { TOption } from '@vlabs/uikit/types';

interface AnalyticsTypeMenuItemProps {
  type: TOption;
  onClick: (value: string) => void;
}

/**
 * Пункт меню «Добавить видеоаналитику» — единый для страницы группы и формы создания группы,
 * чтобы иконка, текст и значение не расходились между местами.
 */
function AnalyticsTypeMenuItem({
  type,
  onClick,
}: AnalyticsTypeMenuItemProps): React.JSX.Element {
  return (
    <DropdownMenu.Item
      decorationLeft={<DetectionIcon />}
      onClick={() => onClick(type.value)}
    >
      {type.label}
    </DropdownMenu.Item>
  );
}

export { AnalyticsTypeMenuItem };
